module.exports = __webpack_public_path__ + "static/media/line-chart.3e1ce16d.svg";